import useMartyContext from 'hooks/useMartyContext';
import vipShippingSrc from 'images/vip-shipping.svg';
import { FEATURE_PDP_OOS_UX } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';

export default function TwoDayShippingPerk() {
  const { testId } = useMartyContext();

  const { isEnrolled: isPdpOosUx } = useIsEnrolledInVariant({ featureFlag: FEATURE_PDP_OOS_UX, isZapposOnly: false });

  return (
    <div className="flex h-5 items-center justify-start" data-test-id={testId('shippingPerkBox')}>
      {isPdpOosUx && <img className="mr-2 h-4" src={vipShippingSrc} alt="Vip Shipping" />}
      <div className="flex w-full items-center">
        <strong className="mr-1">FREE</strong>upgraded shipping & returns with
        {/* margin top aligns the prime logo text with the text above */}
        <img className="h5 ml-1 mt-2 w-8" src="https://m.media-amazon.com/images/G/01/zappos/ui/prime-icon.svg" alt="Amazon Prime" />
      </div>
    </div>
  );
}
